import React, { useState } from "react";
import { Field } from "components/base/Form";
import { CubeSizeInput } from "components/shared/ItemSizeInput";
import Button from "components/base/Button";

const emptyProduct = {
  name: "",
  number: "",
  outerCartonX: 0,
  outerCartonY: 0,
  outerCartonZ: 0,
  quantityPerCarton: 0,
  ctnNetWeight: 0,
  ctnGrossWeight: 0,
  customsName: "",
  customsBrand: "",
  customsUsage: "",
  customsValue: 0,
  customsSize: "",
  customsMaterials: "",
};

function SpecialItemForm({ onSaveSpecialItem }) {
  const [product, setProduct] = useState(emptyProduct);

  const outerCartonCbm = (product) => {
    const dimensions = [
      parseFloat(product.outerCartonX),
      parseFloat(product.outerCartonY),
      parseFloat(product.outerCartonZ),
    ];
    return dimensions.every(Boolean)
      ? ((dimensions[0] + 0.5) *
          (dimensions[1] + 0.5) *
          (dimensions[2] + 0.5)) /
          1000000
      : 0;
  };

  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <div className="flex space-x-8">
          <Field
            label="Name(英文)"
            value={product.name}
            onChange={(name) => setProduct({ ...product, name })}
          />
          <Field
            label="Number"
            value={product.number}
            onChange={(number) => setProduct({ ...product, number })}
          />
        </div>

        <div className="flex space-x-8">
          <Field
            label="Qty / CTN"
            value={product.quantityPerCarton}
            onChange={(quantityPerCarton) =>
              setProduct({ ...product, quantityPerCarton })
            }
          />

          <Field
            label="CTN N.W."
            value={product.ctnNetWeight}
            onChange={(ctnNetWeight) =>
              setProduct({ ...product, ctnNetWeight })
            }
            suffix="kg"
          />

          <Field
            label="CTN G.W."
            value={product.ctnGrossWeight}
            onChange={(ctnGrossWeight) =>
              setProduct({ ...product, ctnGrossWeight })
            }
            suffix="kg"
          />
        </div>

        <div className="flex items-center space-x-4">
          <div className="w-44">
            <label>Outer Carton Size: </label>
            <div className="text-xs text-gray-600 dark:text-gray-300">
              Size 长(x) x 宽(z) x 高(y):
            </div>
          </div>
          <CubeSizeInput
            x={product.outerCartonX}
            y={product.outerCartonY}
            z={product.outerCartonZ}
            unit="cm"
            onChange={({ x, y, z }) =>
              setProduct((prev) => ({
                ...prev,
                outerCartonX: x,
                outerCartonY: y,
                outerCartonZ: z,
              }))
            }
          />

          <div>
            <div>
              <label>CBM: </label>{" "}
              {outerCartonCbm(product)
                ? outerCartonCbm(product).toFixed(4)
                : "0"}{" "}
              m³
            </div>
            <div className="text-xs text-gray-600 dark:text-gray-300">
              ((x + 0.5) * (y + 0.5) * (z + 0.5)) / (100 * 100 * 100)
            </div>
          </div>
        </div>
      </section>

      <hr />

      <section className="space-y-4">
        <h3>Customs Info</h3>

        <div className="flex space-x-4">
          <Field
            label="Name"
            value={product.customsName}
            onChange={(customsName) => setProduct({ ...product, customsName })}
          />
          <Field
            label="Brand"
            value={product.customsBrand}
            onChange={(customsBrand) =>
              setProduct({ ...product, customsBrand })
            }
          />

          <Field
            label="Usage"
            value={product.customsUsage}
            onChange={(customsUsage) =>
              setProduct({ ...product, customsUsage })
            }
          />
          <Field
            label="Value"
            value={product.customsValue}
            onChange={(customsValue) =>
              setProduct({ ...product, customsValue })
            }
          />
        </div>

        <Field
          label="Size"
          value={product.customsSize}
          onChange={(customsSize) => setProduct({ ...product, customsSize })}
        />

        <Field
          label="Material"
          value={product.customsMaterials}
          onChange={(customsMaterials) =>
            setProduct({ ...product, customsMaterials })
          }
        />
      </section>

      <hr />

      <div className="flex mt-4 lg:mt-8">
        <Button
          onClick={() =>
            onSaveSpecialItem({
              productName: product.name,
              itemNumber: product.number,
              qtyPerCarton: product.quantityPerCarton || 0,
              netWeight: product.ctnNetWeight || 0,
              grossWeight: product.ctnGrossWeight || 0,
              outerCartonX: product.outerCartonX || 0,
              outerCartonY: product.outerCartonY || 0,
              outerCartonZ: product.outerCartonZ || 0,
              customsName: product.customsName,
              customsBrand: product.customsBrand,
              customsUsage: product.customsUsage,
              customsValue: product.customsValue || 0,
              customsSize: product.customsSize,
              customsMaterials: product.customsMaterials,
            })
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
}

export default SpecialItemForm;
